import React from 'react';
import usePolygonsStore from '../store/usePolygonsStore';
import useMapsStore from '../store/useMapsStore';
import settings, { isBlock } from '../util/config';
import { BRAND_CCS, BRAND_CCS_TEXT, BRAND_CMP_TEXT } from 'common/types/community';
function CommunityCard({ communityCardRef }) {
    const { community } = usePolygonsStore(["community"]);
    const { brand } = useMapsStore();
    return community ? (React.createElement("div", { ref: communityCardRef, className: "viewport-map__community-card" },
        React.createElement("img", { className: "viewport-map__community-card__brand-logo", src: brand === BRAND_CCS ? settings.CCSLogo : settings.CMPLogo, alt: brand === BRAND_CCS ? BRAND_CCS_TEXT : BRAND_CMP_TEXT }),
        React.createElement("div", { className: "viewport-map__community-card__content" },
            !isBlock && React.createElement("h1", { className: "viewport-map__community-card__title" }, community.Properties.Name),
            isBlock && React.createElement("h2", { className: "viewport-map__community-card__title" }, community.Properties.Name),
            React.createElement("p", { className: "viewport-map__community-card__area-info" },
                community.Properties.City,
                ", ",
                community.Properties.State,
                ' ',
                community.Properties.PostalCode)))) : (React.createElement("p", null, "Loading..."));
}
export default CommunityCard;
export const MemoizedCommunityCard = React.memo(CommunityCard);
